var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderCom'),_c('router-view'),_c('FooterCom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }